module.exports = __webpack_public_path__ + "media/12_22.2ea0b332.wav";